export const whatsappConfig: Record<
  string,
  { number: string; message: string; showWhatsapp: boolean }
> = {
  'madinahdryclean.com': {
    number: '447440633747',
    message: `Hello, I would like to inquire about your services. Could you please provide me with more information?`,
    showWhatsapp: true,
  },
};
whatsappConfig['www.madinahdryclean.com'] =
  whatsappConfig['madinahdryclean.com'];
